define('views/components/manual_payment_transaction/manual_payment_transaction',['require','backbone','text!templates/components/manual_payment_transaction/manual_payment_transaction.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/manual_payment_transaction/manual_payment_transaction.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'transaction-item'
    });
});
